export default "__VITE_ASSET__Bo77kFWq__"